import React from 'react'
import PropTypes from 'prop-types'
import WorkLayout from '../../../layouts/Work'

const buildGoogleSlidesEmbedUrl = ({
  presentationId,
  start = false,
  loop = false,
  delayMs = 60000
}) => {
  const baseUrl = `https://docs.google.com/presentation/d/e/${presentationId}/pubembed`
  const params = new URLSearchParams({
    start: String(start),
    loop: String(loop),
    delayms: String(delayMs)
  })

  return `${baseUrl}?${params.toString()}`
}

const GoogleSlidesCaseStudy = ({
  pageTitle,
  date,
  role,
  company,
  presentationId,
  pdfLink,
  start,
  loop,
  delayMs,
  figmaLink,
  videoHref
}) => {
  const embedUrl = buildGoogleSlidesEmbedUrl({
    presentationId,
    start,
    loop,
    delayMs
  })

  return (
    <WorkLayout
      pageTitle={pageTitle}
      date={date}
      role={role}
      company={company}
      slidesLink={pdfLink}
      figmaLink={figmaLink}
      videoHref={videoHref}
    >
      <section className="work-slide-deck" aria-label={`${company} case study slide deck`}>
        <iframe
          src={embedUrl}
          title={`${company} case study slide deck`}
          frameBorder="0"
          allowFullScreen
          loading="lazy"
        />
        <p className="work-slide-deck__caption">Click the menu to enter full screen.</p>
      </section>
    </WorkLayout>
  )
}

GoogleSlidesCaseStudy.defaultProps = {
  date: '',
  role: '',
  pdfLink: '',
  start: false,
  loop: false,
  delayMs: 60000,
  figmaLink: '',
  videoHref: ''
}

GoogleSlidesCaseStudy.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  date: PropTypes.string,
  role: PropTypes.string,
  company: PropTypes.string.isRequired,
  presentationId: PropTypes.string.isRequired,
  pdfLink: PropTypes.string,
  start: PropTypes.bool,
  loop: PropTypes.bool,
  delayMs: PropTypes.number,
  figmaLink: PropTypes.string,
  videoHref: PropTypes.string
}

export default GoogleSlidesCaseStudy
